export default "__VITE_ASSET__PzP3r4KI__"